<nav aria-label="Breadcrumb" class="breadcrumbComponent">
  <ol>
    <li [ngClass]="getClassFor('tickets')" [attr.aria-current]="ariaCurrentFor('tickets')">
      {{ 'breadcrumb_tickets' | i18next }}
    </li>
    <li [ngClass]="getClassFor('results')" [attr.aria-current]="ariaCurrentFor('results')">
      {{ 'breadcrumb_results' | i18next }}
    </li>
    <li [ngClass]="getClassFor('details')" [attr.aria-current]="ariaCurrentFor('details')">
      {{ 'breadcrumb_details' | i18next }}
    </li>
    <li [ngClass]="getClassFor('confirmation')" [attr.aria-current]="ariaCurrentFor('confirmation')">
      {{ 'breadcrumb_confirmation' | i18next }}
    </li>
  </ol>
</nav>
